module.exports = __webpack_public_path__ + "fonts/Inter-500-cyrillic-ext50.251d36f.woff2";